export default "__VITE_ASSET__M4_VFBj2__"